import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bootstrap-theme-kit',
  templateUrl: './bootstrap-theme-kit.component.html',
  styleUrls: ['./bootstrap-theme-kit.component.scss']
})
export class BootstrapThemeKitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
